var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"voc-status"},[_c('span',{staticClass:"status-color",style:({ backgroundColor: _vm.color })}),_c('span',{staticClass:"status-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }